"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyContentContainer = exports.ModalContent = exports.CloseButtonContainer = exports.ModalOverlay = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const view_1 = __importDefault(require("../box/view"));
const setScrollableOverlay = (props) => props.scrollable
    ? (0, styled_components_1.css) `
        width: 100%;
        overflow: scroll;
      `
    : (0, styled_components_1.css) ``;
const setScrollableModalContent = (props) => props.scrollable
    ? (0, styled_components_1.css) `
        overflow: scroll;
      `
    : (0, styled_components_1.css) ``;
const setPosition = (props) => props.hasCloseButton
    ? (0, styled_components_1.css) `
        position: relative;
        width: 80%;
      `
    : (0, styled_components_1.css) ``;
exports.ModalOverlay = (0, styled_components_1.default)(view_1.default) `
  background-color: ${(props) => {
    const { overlayColor, hasOverlay } = props;
    return hasOverlay ? overlayColor : 'transparent';
}};
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1008;
  ${setScrollableOverlay};
`;
exports.CloseButtonContainer = styled_components_1.default.div `
  color: #262d34;
  font-size: 33px;
  padding-left: 10px;
  align-self: center;
  position: fixed;
  top: 20px;
  right: 30px;
`;
exports.ModalContent = (0, styled_components_1.default)(view_1.default) `
  z-index: 1009;
  ${setScrollableModalContent};
  ${setPosition};
`;
exports.DummyContentContainer = styled_components_1.default.div `
  padding: 30px;
  background-color: #fff;
  border: 1px solid;
  border-color: #d5d9d9;
  border-radius: 8px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
